module.exports = __webpack_public_path__ + "img/mic.52ccdf8b.svg";